<template>
    <div class="Sorting">
        <DropdownWithTrigger>
            <template #trigger="{active}">
                <div :class="['Sorting__trigger', {'Sorting__trigger--active': active}]">
                    <span class="Sorting__text">
                        <span class="hide-mobile">Сортировать:&nbsp;</span>
                        {{activeSortTitle}}
                    </span>
                    <ArrowDownIcon class="Sorting__arrow"/>
                </div>
            </template>
            <template #dropdown="{close}">
                <div class="Sorting__dropdown">
                    <SortingGroup
                            v-for="(sorts, sortType) of sortsList"
                            :sort-list="sorts"
                            :sort-type="sortType"
                            :close="close"
                            :key="sortType"
                    />
                </div>
            </template>
        </DropdownWithTrigger>
    </div>
</template>

<script>
import DropdownWithTrigger from "@/components/DropdownWithTrigger";
import ArrowDownIcon from '@/assets/image/icons/select-arrow-down.svg?inline'
import SortingGroup from "@/components/SortingGroup";
import {mapState} from "vuex";

export default {
    name: "Sorting",
    components: {
        DropdownWithTrigger,
        ArrowDownIcon,
        SortingGroup,
    },
    data: () => ({
        sortsList: {
            new: [
                {
                    title: 'Cначала новые',
                    rise: false,
                },
                {
                    title: 'Cначала старые',
                    rise: true,
                },
            ],
            price: [
                {
                    title: 'По возрастанию цены',
                    rise: false,
                },
                {
                    title: 'По уменьшению цены',
                    rise: true,
                },
            ],
            area: [
                {
                    title: 'По увеличению площади',
                    rise: false,
                },
                {
                    title: 'По уменьшению площади',
                    rise: true,
                },
            ],
        }
    }),
    computed: {
        activeSortTitle() {
            const {type, rise} = this.sort;
            const sort = this.sortsList[type].find(sort => sort.rise === rise);
            if (sort) {
                return sort.title;
            }
            return ''
        },
        ...mapState(['sort'])
    }
}
</script>

<style lang="scss">
.Sorting {

  &__trigger {

    &--active {

      .Sorting__arrow {
        transform: rotate(-180deg);
      }
    }
  }

  &__text {
    margin-right: 8px;
  }

  &__dropdown {
    padding: 18px 0;
  }
}
</style>